<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
  <rect x="8" y="8" width="12" height="12" rx="2" stroke="currentColor" stroke-width="1.75" />
  <path
    d="M16 8V6C16 4.8954 15.1046 4 14 4H6C4.8954 4 4 4.8954 4 6V14C4 15.1046 4.8954 16 6 16H8"
    stroke="currentColor"
    stroke-width="1.75"
    stroke-linejoin="round"
  />
</svg>
